import React, { useState } from 'react';
import { Calendar, Send, CheckCircle } from 'lucide-react';
export function ContactReservation() {
  const [reservationStatus, setReservationStatus] = useState<'idle' | 'submitting' | 'success'>('idle');
  const [contactStatus, setContactStatus] = useState<'idle' | 'submitting' | 'success'>('idle');
  const handleReservationSubmit = (e: FormEvent) => {
    e.preventDefault();
    setReservationStatus('submitting');
    // Simulate API call
    setTimeout(() => {
      setReservationStatus('success');
      // Reset after 3 seconds
      setTimeout(() => setReservationStatus('idle'), 5000);
    }, 1500);
  };
  const handleContactSubmit = (e: FormEvent) => {
    e.preventDefault();
    setContactStatus('submitting');
    // Simulate API call
    setTimeout(() => {
      setContactStatus('success');
      // Reset after 3 seconds
      setTimeout(() => setContactStatus('idle'), 5000);
    }, 1500);
  };
  return <section id="reservation" className="py-20 md:py-24 bg-background relative overflow-hidden" data-id="element-34">
      {/* Background decoration */}
      <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-primary/50 to-transparent" data-id="element-35"></div>

      <div className="container mx-auto px-4" data-id="element-36">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16" data-id="element-37">
          {/* Reservation Form */}
          <div className="bg-card p-8 rounded-xl border border-border shadow-lg" data-id="element-38">
            <div className="flex items-center gap-3 mb-6" data-id="element-39">
              <Calendar className="w-6 h-6 text-primary" data-id="element-40" />
              <h2 className="font-serif text-2xl md:text-3xl font-bold text-foreground" data-id="element-41">
                Reserve a Table
              </h2>
            </div>

            {reservationStatus === 'success' ? <div className="h-full flex flex-col items-center justify-center py-12 text-center animate-in fade-in" data-id="element-42">
                <div className="w-16 h-16 bg-green-500/10 rounded-full flex items-center justify-center mb-4" data-id="element-43">
                  <CheckCircle className="w-8 h-8 text-green-500" data-id="element-44" />
                </div>
                <h3 className="text-xl font-bold text-foreground mb-2" data-id="element-45">
                  Request Received!
                </h3>
                <p className="text-muted-foreground" data-id="element-46">
                  We'll confirm your booking shortly via email or phone.
                </p>
              </div> : <form onSubmit={handleReservationSubmit} className="space-y-4" data-id="element-47">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-48">
                  <div className="space-y-2" data-id="element-49">
                    <label htmlFor="res-name" className="text-sm font-medium text-muted-foreground" data-id="element-50">
                      Name
                    </label>
                    <input id="res-name" required type="text" className="w-full bg-surface border border-border rounded-md px-4 py-2 text-foreground focus:border-primary focus:ring-1 focus:ring-primary outline-none transition-all" placeholder="Your name" data-id="element-51" />
                  </div>
                  <div className="space-y-2" data-id="element-52">
                    <label htmlFor="res-phone" className="text-sm font-medium text-muted-foreground" data-id="element-53">
                      Phone
                    </label>
                    <input id="res-phone" required type="tel" className="w-full bg-surface border border-border rounded-md px-4 py-2 text-foreground focus:border-primary focus:ring-1 focus:ring-primary outline-none transition-all" placeholder="+353..." data-id="element-54" />
                  </div>
                </div>

                <div className="space-y-2" data-id="element-55">
                  <label htmlFor="res-email" className="text-sm font-medium text-muted-foreground" data-id="element-56">
                    Email
                  </label>
                  <input id="res-email" required type="email" className="w-full bg-surface border border-border rounded-md px-4 py-2 text-foreground focus:border-primary focus:ring-1 focus:ring-primary outline-none transition-all" placeholder="email@example.com" data-id="element-57" />
                </div>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-58">
                  <div className="space-y-2" data-id="element-59">
                    <label htmlFor="res-date" className="text-sm font-medium text-muted-foreground" data-id="element-60">
                      Date
                    </label>
                    <input id="res-date" required type="date" className="w-full bg-surface border border-border rounded-md px-4 py-2 text-foreground focus:border-primary focus:ring-1 focus:ring-primary outline-none transition-all" data-id="element-61" />
                  </div>
                  <div className="space-y-2" data-id="element-62">
                    <label htmlFor="res-time" className="text-sm font-medium text-muted-foreground" data-id="element-63">
                      Time
                    </label>
                    <select id="res-time" required className="w-full bg-surface border border-border rounded-md px-4 py-2 text-foreground focus:border-primary focus:ring-1 focus:ring-primary outline-none transition-all" data-id="element-64">
                      <option value="" data-id="element-65">Select</option>
                      {Array.from({
                    length: 28
                  }).map((_, i) => {
                    const hour = Math.floor(i / 2) + 9;
                    const minute = i % 2 === 0 ? '00' : '30';
                    return <option key={i} value={`${hour}:${minute}`} data-id="element-66">{`${hour}:${minute}`}</option>;
                  })}
                    </select>
                  </div>
                  <div className="space-y-2" data-id="element-67">
                    <label htmlFor="res-guests" className="text-sm font-medium text-muted-foreground" data-id="element-68">
                      Guests
                    </label>
                    <select id="res-guests" required className="w-full bg-surface border border-border rounded-md px-4 py-2 text-foreground focus:border-primary focus:ring-1 focus:ring-primary outline-none transition-all" data-id="element-69">
                      {[1, 2, 3, 4, 5, 6, 7, 8, 9, '10+'].map(num => <option key={num} value={num} data-id="element-70">
                          {num} {num === 1 ? 'Person' : 'People'}
                        </option>)}
                    </select>
                  </div>
                </div>

                <div className="space-y-2" data-id="element-71">
                  <label htmlFor="res-notes" className="text-sm font-medium text-muted-foreground" data-id="element-72">
                    Special Requests
                  </label>
                  <textarea id="res-notes" rows={3} className="w-full bg-surface border border-border rounded-md px-4 py-2 text-foreground focus:border-primary focus:ring-1 focus:ring-primary outline-none transition-all resize-none" placeholder="Allergies, high chair, booth preference..." data-id="element-73"></textarea>
                </div>

                <button type="submit" disabled={reservationStatus === 'submitting'} className="w-full bg-primary text-primary-foreground font-bold py-3 rounded-md hover:bg-primary/90 transition-all disabled:opacity-70 disabled:cursor-not-allowed mt-2" data-id="element-74">
                  {reservationStatus === 'submitting' ? 'Sending Request...' : 'Request Reservation'}
                </button>

                <p className="text-xs text-muted-foreground text-center mt-4" data-id="element-75">
                  We'll confirm your booking via email or phone.
                </p>
              </form>}
          </div>

          {/* Contact Form */}
          <div className="flex flex-col justify-center" data-id="element-76">
            <div className="mb-8" data-id="element-77">
              <h2 className="font-serif text-2xl md:text-3xl font-bold text-foreground mb-4" data-id="element-78">
                Get in Touch
              </h2>
              <p className="text-muted-foreground" data-id="element-79">
                Have a question about an event, dietary requirements, or lost
                property? Send us a message and we'll get back to you.
              </p>
            </div>

            {contactStatus === 'success' ? <div className="bg-card p-8 rounded-xl border border-border flex flex-col items-center justify-center text-center animate-in fade-in" data-id="element-80">
                <div className="w-16 h-16 bg-green-500/10 rounded-full flex items-center justify-center mb-4" data-id="element-81">
                  <CheckCircle className="w-8 h-8 text-green-500" data-id="element-82" />
                </div>
                <h3 className="text-xl font-bold text-foreground mb-2" data-id="element-83">
                  Message Sent!
                </h3>
                <p className="text-muted-foreground" data-id="element-84">
                  We'll be in touch shortly.
                </p>
              </div> : <form onSubmit={handleContactSubmit} className="space-y-4 bg-card/50 p-6 rounded-xl border border-border/50" data-id="element-85">
                <div className="space-y-2" data-id="element-86">
                  <label htmlFor="contact-name" className="text-sm font-medium text-muted-foreground" data-id="element-87">
                    Name
                  </label>
                  <input id="contact-name" required type="text" className="w-full bg-surface border border-border rounded-md px-4 py-2 text-foreground focus:border-primary focus:ring-1 focus:ring-primary outline-none transition-all" placeholder="Your name" data-id="element-88" />
                </div>

                <div className="space-y-2" data-id="element-89">
                  <label htmlFor="contact-email" className="text-sm font-medium text-muted-foreground" data-id="element-90">
                    Email
                  </label>
                  <input id="contact-email" required type="email" className="w-full bg-surface border border-border rounded-md px-4 py-2 text-foreground focus:border-primary focus:ring-1 focus:ring-primary outline-none transition-all" placeholder="email@example.com" data-id="element-91" />
                </div>

                <div className="space-y-2" data-id="element-92">
                  <label htmlFor="contact-message" className="text-sm font-medium text-muted-foreground" data-id="element-93">
                    Message
                  </label>
                  <textarea id="contact-message" required rows={4} className="w-full bg-surface border border-border rounded-md px-4 py-2 text-foreground focus:border-primary focus:ring-1 focus:ring-primary outline-none transition-all resize-none" placeholder="How can we help?" data-id="element-94"></textarea>
                </div>

                <button type="submit" disabled={contactStatus === 'submitting'} className="w-full border border-primary text-primary font-bold py-3 rounded-md hover:bg-primary/10 transition-all disabled:opacity-70 disabled:cursor-not-allowed flex items-center justify-center gap-2" data-id="element-95">
                  {contactStatus === 'submitting' ? 'Sending...' : <>
                      Send Message <Send className="w-4 h-4" data-id="element-96" />
                    </>}
                </button>

                <p className="text-xs text-muted-foreground text-center mt-2" data-id="element-97">
                  We reply fast during opening hours.
                </p>
              </form>}
          </div>
        </div>
      </div>
    </section>;
}